import { StyledSVG } from './GrabButton.styled'

export interface GrabButtonProps {
  text: string
  disabled?: boolean
  hidden?: boolean
  show?: boolean
  onClick?: () => void
}

const GrabButton = ({ show = true, text, hidden = false, disabled, onClick }: GrabButtonProps) => {
  if (!show || hidden) {
    return null
  }
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width="260"
      height="30"
      viewBox="0 0 180 22"
      fill="none"
      disabled={disabled}
      onClick={!hidden ? onClick : undefined}
    >
      <path
        d="M91.362 21.3306H34.1854C34.1854 21.3306 34.0422 21.3306 33.9706 21.2589L29.2089 16.4909L29.6385 16.0607L34.3286 20.757H91.3978V21.3664L91.362 21.3306Z"
        fill="white"
      />
      <path
        d="M52.8028 21.0437L50.2966 18.5343H35.546C35.546 18.5343 35.4028 18.5343 35.3312 18.4626L27.8485 10.97H5.04229L1.28303 14.7342L0.853394 14.304L4.68426 10.4681C4.68426 10.4681 4.82747 10.3964 4.89907 10.3964H27.9559C27.9559 10.3964 28.0991 10.3964 28.1707 10.4681L35.6534 17.9607H50.4041C50.4041 17.9607 50.5473 17.9607 50.6189 18.0324L53.1967 20.6136L52.767 21.0437H52.8028Z"
        fill="white"
      />
      <path
        d="M36.6572 4.26721L30.7242 10.4121L36.6572 16.118H51.4896L54.8799 19.6294H126.923H137.094H147L154 12.9999L145.5 4.26721H36.6572Z"
        fill="#F30C6D"
      />
      <path
        d="M148.575 21.3306H91.3979V20.7212H148.467L156.811 12.3715L157.24 12.8017L148.825 21.2231C148.825 21.2231 148.682 21.2948 148.61 21.2948L148.575 21.3306Z"
        fill="white"
      />
      <path
        d="M50.4399 18.5343H35.5819C35.5819 18.5343 35.4387 18.5343 35.3671 18.4626L27.8127 10.8983L28.2424 10.4681L35.7251 17.9607H50.4757V18.5702L50.4399 18.5343Z"
        fill="white"
      />
      <path
        d="M28.2424 10.8984L27.8127 10.4682L35.3671 2.90385C35.3671 2.90385 35.5103 2.83215 35.5819 2.83215H91.3622V3.4416H35.6893L28.2066 10.9342L28.2424 10.8984Z"
        fill="white"
      />
      <path
        d="M154.518 10.8983L147.035 3.40571H91.3621V2.79626H147.142C147.142 2.79626 147.286 2.79626 147.357 2.86796L157.038 12.5588L156.608 12.989L154.518 10.8983Z"
        fill="white"
      />
      <path
        d="M121.973 3.29818L119.252 0.573596H63.5078L60.7868 3.29818L60.3572 2.86798L63.1498 0.0716996C63.1498 0.0716996 63.293 0 63.3646 0H119.36C119.36 0 119.503 0 119.575 0.0716996L122.367 2.86798L121.937 3.29818H121.973Z"
        fill="white"
      />
      <circle cx="1.7069" cy="14.5087" r="1.7069" fill="white" />
      <text
        x="51%"
        y="60%"
        textAnchor="middle"
        dominantBaseline="middle"
        fill="white"
        className="text-white text-2xs font-bold"
      >
        {text}
      </text>
    </StyledSVG>
  )
}

export default GrabButton
